/* eslint-disable @typescript-eslint/no-explicit-any */
import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, ReactElement } from "react";
import { motion } from "framer-motion";
// import ConsultationIcon from "../Icons/ConsultationIcon";
import CoursesIcon from "../Icons/CoursesIcon";
import StudentsIcon from "../Icons/StudentsIcon";
import StudentIcon from "../Icons/StudentIcon";
import Logo from "../../assets/NWLogo.png";
import clsx from "clsx";
import React from "react";
// import QuizzesIcon from "../Icons/QuizzesIcon";
import MenuIcon from "../Icons/MenuIcon";
import QuestionMarkIcon from "../Icons/QuestionMarkIcon";
import TeamIcon from "../Icons/TeamIcon";
import MoneyIcon from "../Icons/MoneyIcon";
import ReviewIcon from "../Icons/ReviewIcon";
import FeedbackIcon from "../Icons/FeedbackIcon";
import AnnouncementIcon from "../Icons/AnnouncementIcon";
import CouponIcon from "../Icons/CouponIcon";
import PackageIcon from "../Icons/PackageIcon";
import BlogIcon from "../Icons/BlogIcon";
import {
  Handshake,
  HeadphonesIcon,
  ListCollapse,
  Mail,
  SquarePercent,
  UserCog2,
} from "lucide-react";
import { BookOpenText } from "lucide-react";
import HostQuizIcon from "../Icons/HostQuizIcon";
import BankIcon from "../Icons/BankIcon";
import { useUserDataStore } from "../../stores/user";
import GenerateExamIcon from "../Icons/GenerateExamIcon";
interface ISidebarLinks {
  children: { title: string; icon: ReactElement; roles: string[] }[];
}

const Sidebar = () => {
  const location = useLocation();
  const { userData } = useUserDataStore();
  const userRole = userData?.role || "";
  const sidebarLinks: ISidebarLinks[] = [
    {
      children: [
        {
          title: "Students",
          icon: <StudentsIcon />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: "Courses",
          icon: <CoursesIcon />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: userRole === "admin" ? "Books" : "Books Requests",
          icon: <BookOpenText />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: "Categories",
          icon: <ListCollapse />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Packages",
          icon: <PackageIcon />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: "Assign Course",
          icon: <StudentIcon />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: "Announcement",
          icon: <AnnouncementIcon />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Coupons",
          icon: <CouponIcon />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: "Requests",
          icon: <MoneyIcon />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: "Instructors",
          icon: <TeamIcon />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Consultants",
          icon: <Handshake />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: "Training",
          icon: <Handshake />,
          roles: ["admin", "sales"], // Admin only
        },

        {
          title: "Team",
          icon: <TeamIcon />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Support",
          icon: <HeadphonesIcon />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: "Reviews",
          icon: <ReviewIcon />,
          roles: ["admin", "sales"], // Admin only
        },
        {
          title: "FAQs",
          icon: <QuestionMarkIcon />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Feedback",
          icon: <FeedbackIcon />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Blogs",
          icon: <BlogIcon />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Host Quizs",
          icon: <HostQuizIcon />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Question Bank",
          icon: <BankIcon />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Sales",
          icon: <SquarePercent />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Mails",
          icon: <Mail />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Exam Maker",
          icon: <GenerateExamIcon />,
          roles: ["admin"], // Admin only
        },
        {
          title: "Admins",
          icon: <UserCog2 />,
          roles: ["admin"], // Admin only
        },
      ],
    },
  ];

  const [isOpen, setIsOpen] = useState<boolean>(true);
  return (
    <>
      <motion.aside
        animate={{ minWidth: isOpen ? "240px" : "120px" }}
        className={`px-2.5 pb-[53px] mr-0 whitespace-nowrap relative left-0 flex flex-col justify-between z-50 bg-white border border-slate border-opacity-20 pt-4 `}
      >
        <div>
          <div
            onClick={() => setIsOpen(!isOpen)}
            className="cursor-pointer top-[22px] absolute flex justify-center items-center -right-[50px]"
          >
            <MenuIcon />
          </div>
          <div className="mx-auto">
            <Link
              className="flex items-center gap-1 w-full justify-center mb-7 "
              to="/"
            >
              <img src={Logo} className={`w-10 h-10`} />
              <h1
                className={`text-primary font-bold text-sm -tracking-[0.02em] ${
                  isOpen ? "block" : "hidden"
                }`}
              >
                NileWise
              </h1>
            </Link>
          </div>
          <div className="flex flex-col  w-full ">
            {sidebarLinks.map((link) => (
              <div className="flex flex-col items-center justify-center gap-3">
                {link.children
                  .filter(
                    (child) => !child.roles || child.roles.includes(userRole)
                  ) // Filter links
                  .map((child) => {
                    const isActive =
                      location.pathname ===
                      `/${child.title.toLowerCase().split(" ").join("-")}`;
                    return (
                      <NavLink
                        to={`${child.title.toLowerCase().split(" ").join("-")}`}
                        className={({ isActive: isNavLinkActive }) =>
                          clsx(
                            "relative h-[50px] max-w-[192px] cursor-pointer transition w-full rounded-lg items-center gap-4 flex text-hayak_tertiary ",
                            {
                              "bg-lightBlue !text-white": isNavLinkActive,
                            }
                          )
                        }
                      >
                        <Link
                          to={`${child.title
                            .toLowerCase()
                            .split(" ")
                            .join("-")}`}
                          className="h-12 w-1 bg-lightBlue rounded-tr-md rounded-br-md fixed left-0"
                        ></Link>
                        <div className={`${isOpen ? "pl-5" : "mx-auto"} `}>
                          {React.cloneElement(child.icon, {
                            isSelected: isActive,
                          })}
                        </div>
                        {!isOpen && (
                          <span
                            className={`absolute left-full ml-4 transition duration-300 font-semibold rounded-md px-4 py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible text-sm`}
                          >
                            {child.title}
                          </span>
                        )}

                        <motion.div
                          animate={{
                            opacity: isOpen ? "1" : "0",
                            display: isOpen ? "block" : "none",
                          }}
                          className="text-inherit text-lg transition duration-200"
                        >
                          {child.title}
                        </motion.div>
                      </NavLink>
                    );
                  })}
              </div>
            ))}
          </div>
        </div>
      </motion.aside>
    </>
  );
};

export default Sidebar;
